import React from "react";
import { useLang } from "../LanguageContext";
import ScrollReveal from "./ScrollReveal";
import AiTab from "./AiTab";

export default function AiAtScaleSection() {
  const { lang } = useLang();

  return (
    <section className="aiatscale-section">
      <div className="section-inner">
        <ScrollReveal>
          <h2 className="section-heading">
            {lang === "en" ? "AI at Scale" : "IA à Grande Échelle"}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={200}>
          <AiTab />
        </ScrollReveal>
      </div>
    </section>
  );
}
